var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrayTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 42,
    viewBox: "0 0 45 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4474 19L21.7648 25L42.8229 5M40.7171 21V35C40.7171 36.0609 40.2733 37.0783 39.4835 37.8284C38.6937 38.5786 37.6224 39 36.5054 39H7.02412C5.90713 39 4.83589 38.5786 4.04605 37.8284C3.25622 37.0783 2.8125 36.0609 2.8125 35V7C2.8125 5.93913 3.25622 4.92172 4.04605 4.17157C4.83589 3.42143 5.90713 3 7.02412 3H30.188",
    stroke: "#EEF7FE",
    strokeWidth: 4.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayTick);
export default "data:image/svg+xml,%3csvg width='45' height='42' viewBox='0 0 45 42' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M15.4474 19L21.7648 25L42.8229 5M40.7171 21V35C40.7171 36.0609 40.2733 37.0783 39.4835 37.8284C38.6937 38.5786 37.6224 39 36.5054 39H7.02412C5.90713 39 4.83589 38.5786 4.04605 37.8284C3.25622 37.0783 2.8125 36.0609 2.8125 35V7C2.8125 5.93913 3.25622 4.92172 4.04605 4.17157C4.83589 3.42143 5.90713 3 7.02412 3H30.188' stroke='%23EEF7FE' stroke-width='4.33333' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };